<template>
  <div class="sole-proprietorship-details-body-text">
    <b-container>
      <div>
        <h1 class="text-left mt-2" v-if="selectedSoleProprietorship.name">
          {{ selectedSoleProprietorship.name }}
        </h1>
        <b-row class="information-wrapper">
          <b-col sm="12" md="6" lg="6" xl="8" class="d-flex align-items-center">
            <b-img class="ml-3 mt-2" src="../assets/img/icons/details-magnifier.svg" />
            <div class="text-left">
              <p class="mb-0 information-text">
                Ellenőrizze vállalkozása adatait és tekintse meg lehetőségeit!
              </p>
            </div>
          </b-col>
          <b-col sm="12" md="6" lg="6" xl="4">
            <button type="button" name="button" class="btn btn-primary w-100" @click="nextPage">
              Tovább a lehetőségeimhez
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="sole-proprietorship-holder">
            <div class="sole-proprietorship-details rounded sole-proprietorship-details-vali-hollow-logo">
              <b-row cols="2">
                <b-col v-if="selectedSoleProprietorship.start_date">Alapítás éve </b-col>
                <b-col v-if="selectedSoleProprietorship.start_date">
                  {{ selectedSoleProprietorship.start_date }}
                </b-col>

                <b-col v-if="selectedSoleProprietorship.tax_number">Adószám </b-col>
                <b-col v-if="selectedSoleProprietorship.tax_number">
                  {{ selectedSoleProprietorship.tax_number }}
                </b-col>

                <b-col v-if="selectedSoleProprietorship.main_activities[0].teaor_name">Fő tevékenység </b-col>
                <b-col v-if="selectedSoleProprietorship.main_activities[0].teaor_name">
                  {{ selectedSoleProprietorship.main_activities[0].teaor_name }}
                </b-col>

                <b-col v-if="selectedSoleProprietorship.main_activities[0].teaor_num">Tevékenységi kód </b-col>
                <b-col v-if="selectedSoleProprietorship.main_activities[0].teaor_num">
                  {{ selectedSoleProprietorship.main_activities[0].teaor_num }}
                </b-col>

                <b-col v-if="selectedSoleProprietorship.address[0]">Székhely</b-col>
                <b-col v-if="selectedSoleProprietorship.address[0].address">{{
                  selectedSoleProprietorship.address[0].address
                }}</b-col>

                <b-col v-if="selectedSoleProprietorship.name">Név </b-col>
                <b-col v-if="selectedSoleProprietorship.name">
                  {{ selectedSoleProprietorship.name }}
                </b-col>

                <b-col v-if="selectedSoleProprietorship.registration_num">Regisztrációs szám </b-col>
                <b-col v-if="selectedSoleProprietorship.registration_num">
                  {{ selectedSoleProprietorship.registration_num }}
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row class="ev-info-box">
          <h2>Már az egyéni vállalkozók számára is elérhetőek a VALI.HU szolgáltatásai</h2>
          <b-col class="col-md-4 col-12 col-xs-12 ev-info-text mb-3 mb-sm-0 mt-3 mt-sm-0">
            <b-img src="@/assets/img/vali-icon.svg" alt="Responsive image" class="vali-image"></b-img>
            <p class="mb-0">Személyre szabott támogatási programok</p>
          </b-col>
          <b-col class="col-md-4 col-12 ev-info-text mb-3 mb-sm-0">
            <b-img src="@/assets/img/vali-icon.svg" alt="Responsive image" class="vali-image"></b-img>
            <p class="mb-0">Fejlesztési szolgáltatások</p>
          </b-col>
          <b-col class="col-md-4 col-12 ev-info-text">
            <b-img src="@/assets/img/vali-icon.svg" alt="Responsive image" class="vali-image"></b-img>
            <p class="mb-0">Finanszírozási lehetőségek</p>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col class="offset-md-2 col-md-8 col-sm-12 ev-info-text">
            <p>
              Az egyéni vállalkozók fejlesztési és támogatási lehetőségei eltérőek lehetnek a társas vállalkozások
              lehetőségeihez képest a jogi keretrendszer sajátosságai miatt.
            </p>
          </b-col>
        </b-row>
        <b-row class="information-wrapper-2">
          <b-col sm="12" md="6" lg="5" xl="5" class="d-flex align-items-center justify-content-around mr-4">
            <div class="text-left">
              <p class="mb-0">
                Ellenőrizze a vállalkozása adatait, majd kattintson a tovább gombra a lehetőségekért!
              </p>
            </div>
          </b-col>
          <b-col sm="12" md="6" lg="6" xl="4">
            <button type="button" name="button" class="btn btn-primary w-100 mt-4 mt-md-0" @click="nextPage">
              Tovább
            </button>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SoleProprietorshipDetails',
  props: {
    flowSource: String
  },
  components: {},
  data() {
    return {
      showAllBranch: false,
      userAssignedSoleProprietorship: null
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'selectedSoleProprietorship', 'userSoleProprietorships'])
  },
  methods: {
    async nextPage() {
      if (!this.isAuthenticated) {
        this.$router.push({
          path: 'sole-proprietorship-offers',
          query: { soleProprietorshipId: this.selectedSoleProprietorship.flaggerId }
        })
      } else {
        await this.$store.dispatch('getUserSoleProprietorships', {})

        const soleProprietorshipAssignedToUser = this.userSoleProprietorships.filter(
          userSoleProprietorship =>
            userSoleProprietorship.soleProprietorshipId === this.selectedSoleProprietorship.flaggerId
        )

        if (soleProprietorshipAssignedToUser[0]) {
          this.$router.push({
            path: 'sole-proprietorship-offers-private',
            query: { soleProprietorshipId: this.selectedSoleProprietorship.flaggerId }
          })
        } else {
          this.$router.push({
            path: 'add-sole-proprietorship-private',
            query: { soleProprietorshipId: this.selectedSoleProprietorship.flaggerId }
          })
        }
      }
    }
  },
  async mounted() {
    if (!this.selectedSoleProprietorship) {
      if (this.$route.query.soleProprietorshipId == null) {
        if (this.isAuthenticated) this.$router.push('/home')
        else this.$push('/')
        return
      }
      const getCompanyQueryParams = { value: this.$route.query.soleProprietorshipId }

      this.$gtag.event('sole_proprietorship_details', {
        event_category: 'user_interaction',
        soleProprietorshipId: this.$route.query.soleProprietorshipId
      })
      await this.$store.dispatch('getSoleProprietorship', getCompanyQueryParams)
    }
  }
}
</script>

<style scoped>
.sole-proprietorship-details {
  background-color: white;
  color: var(--color-gray-04);
  text-align: left;
  padding-left: 15px;
  padding-right: 15px;
  border: 1px solid var(--color-gray-02);
}

.sole-proprietorship-details-body-text {
  color: var(--color-gray-04) !important;
}

.sole-proprietorship-details .col {
  margin-bottom: 0px !important;
  padding: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.CompanyBarChart {
  background-color: white;
  padding: 20px;
  border: 1px solid var(--color-gray-02);
  border-radius: 10px;
}

.sole-proprietorship-details > div > .col {
  margin-top: 7px;
}

.sole-proprietorship-details > div > .col:nth-child(odd) {
  color: var(--color-gray-04);
  font-weight: bold;
}

.sole-proprietorship-details > div > .col:nth-child(4n + 3),
.sole-proprietorship-details > div > .col:nth-child(4n + 4) {
  background-color: var(--color-lightgreen);
}

button {
  width: 250px;
  height: 48px;
  font-weight: bold;
}

.sole-proprietorship-details-vali-hollow-logo {
  position: relative;
  overflow: hidden;
}

.information-wrapper {
  background: #f2f8fa;
  margin: 0;
  height: 100px;
  align-items: center;
  margin-bottom: 40px;
  border-radius: 8px;
}

.information-text {
  margin: 0;
  margin-left: 36px;
  font-weight: bold;
  color: #636e72;
}

.information-wrapper-2 {
  margin: 0;
  align-items: center;
  margin-top: 80px;
  margin-bottom: 40px;
}

.ev-info-box {
  margin-right: 0px;
  margin-left: 0px;
  background-color: #f2f8fa;
  margin-top: 80px;
  min-height: 400px;
  padding: 64px;
}

.vali-image {
  padding-right: 24px;
  height: 36px;
}

.ev-info-text {
  font-weight: 400;
  border-radius: 8px;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: left;
  color: #2d3436;
}

@media (max-width: 767px) {
  .information-wrapper {
    height: 200px;
  }

  .sole-proprietorship-holder {
    padding-left: 0;
    padding-right: 0;
  }

  .sole-proprietorship-details {
    border: 0px !important;
  }

  .btn-primary {
    width: 100%;
    margin-bottom: 15px !important;
  }

  .ev-info-box {
    display: flex;
    padding: 16px;
    padding-top: 32px;
    padding-bottom: 32px;
  }
}
</style>
